module.exports = __webpack_public_path__ + "img/vendor-icon-printing.6ea8d72b.png";